const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  uploadContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  uploadBox: {
    width: '174px',
    height: '100px',
    background: '#F9FAFB',
    border: '1px dashed #E5E7EB',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      background: '#F3F4F6',
    },
  },
  plusIcon: {
    fontSize: '24px',
    color: '#9CA3AF',
  },
  imagePreview: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center',
  },
  iconButton: {
    position: 'absolute',
    top: 8,
    right: 8,
  },
  uploadBoxContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    alignItems: 'center',
  },
  thumbnailView: {
    width: '174px',
    height: '100px',
    borderRadius: '12px',
    position: 'relative',
    display: 'flex',
  },
})

export default styles
